import type { FC } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';
import ContestLogoWebp from '@wwe-portal/ui/assets/images/offer/contest-logo.png';

interface ContestLogoProps {
  className?: string;
}
export const ContestLogo: FC<ContestLogoProps> = ({ className }) => {
  return (
    <div
      className={cn(
        '-left-[17px] -top-2 inline-flex h-[34px] w-[34px] items-center justify-center border-none',
        className
      )}
    >
      <img alt="Event logo" height="100%" src={ContestLogoWebp} width="100%" />
    </div>
  );
};
